import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, Fragment as _Fragment, createElementBlock as _createElementBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-6f7da9f0")
const _hoisted_1 = { class: "lg:container lg:mx-auto pt-10 md:pt-12 grid gap-y-8 pb-10 md:pb-0" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "px-4 md:px-0" }, "Stacking", -1)
const _hoisted_3 = { class: "flex justify-between items-start flex-col md:flex-row gap-10" }
const _hoisted_4 = { class: "grid gap-y-6 px-4 md:px-0 pb-0 md:pb-36" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", null, "Stake your HALT tokens and start earn rewards.", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h3", null, "You have staked", -1)
const _hoisted_7 = { class: "text-purple-500" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h3", null, "Available to withdraw", -1)
const _hoisted_9 = { class: "text-purple-500" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("h3", null, "Locked tokens", -1)
const _hoisted_11 = { class: "text-purple-500" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("h3", null, "Rewards", -1)
const _hoisted_13 = { class: "text-purple-500" }
const _hoisted_14 = { class: "action-container" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "grid gap-y-2" }, [
  /*#__PURE__*/_createTextVNode(" Stake your HALT tokens without locking "),
  /*#__PURE__*/_createElementVNode("div", { class: "text-gray-500 text-xs" }, " Tokens wil not be able to participate in the distribution of penalties from past reward programs and you can withdraw them at anytime. ")
], -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "grid gap-y-2" }, [
  /*#__PURE__*/_createTextVNode(" Stake your HALT tokens with locking "),
  /*#__PURE__*/_createElementVNode("div", { class: "text-gray-500 text-xs" }, " You can earn more rewards if you lock your tokens and take part in the event of distribution of the penalties that users have paid during the reward programm. You can withdraw your tokens in 120 days after stoping earning rewards. ")
], -1)
const _hoisted_17 = /*#__PURE__*/_createTextVNode("Unlock")
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "grid gap-y-2" }, " Withdraw your locked tokens ", -1)
const _hoisted_19 = { class: "grid gap-y-2" }
const _hoisted_20 = /*#__PURE__*/_createTextVNode("Withdraw")
const _hoisted_21 = /*#__PURE__*/_createElementVNode("h3", { class: "px-4 md:px-0" }, "Your unlocked staked tokens", -1)
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BalTabs = _resolveComponent("BalTabs")!
  const _component_TokenInput = _resolveComponent("TokenInput")!
  const _component_BalRadio = _resolveComponent("BalRadio")!
  const _component_BalBtn = _resolveComponent("BalBtn")!
  const _component_BalCard = _resolveComponent("BalCard")!
  const _component_BalTable = _resolveComponent("BalTable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", null, [
          _hoisted_6,
          _createElementVNode("h3", _hoisted_7, _toDisplayString(_ctx.formatBn(_ctx.staked)) + " HALT", 1)
        ]),
        _createElementVNode("div", null, [
          _hoisted_8,
          _createElementVNode("h3", _hoisted_9, _toDisplayString(_ctx.formatBn(_ctx.available)) + " HALT", 1)
        ]),
        _createElementVNode("div", null, [
          _hoisted_10,
          _createElementVNode("h3", _hoisted_11, _toDisplayString(_ctx.formatBn(_ctx.locked)) + " HALT", 1)
        ]),
        _createElementVNode("div", null, [
          _hoisted_12,
          _createElementVNode("h3", _hoisted_13, _toDisplayString(_ctx.formatBn(_ctx.rewards)) + " USDC", 1)
        ])
      ]),
      _createVNode(_component_BalCard, { class: "w-full max-w-md" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_BalTabs, {
              tabs: _ctx.tabs,
              modelValue: _ctx.activeTab,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.activeTab = $event))
            }, null, 8, ["tabs", "modelValue"]),
            (_ctx.activeTab === 'deposit')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (_ctx.halter)
                    ? (_openBlock(), _createBlock(_component_TokenInput, {
                        key: 0,
                        amount: _ctx.amountToStake,
                        "onUpdate:amount": _cache[1] || (_cache[1] = ($event: any) => (_ctx.amountToStake = $event)),
                        isValid: _ctx.isDepositInputValid,
                        "onUpdate:isValid": _cache[2] || (_cache[2] = ($event: any) => (_ctx.isDepositInputValid = $event)),
                        address: _ctx.halter.address,
                        weight: 0,
                        name: _ctx.halter.address,
                        fixedToken: "",
                        hideInCurrency: ""
                      }, null, 8, ["amount", "isValid", "address", "name"]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_BalRadio, {
                    name: "depositType",
                    value: "unlocked",
                    modelValue: _ctx.depositType,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.depositType = $event))
                  }, {
                    label: _withCtx(() => [
                      _hoisted_15
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createVNode(_component_BalRadio, {
                    name: "depositType",
                    value: "locked",
                    modelValue: _ctx.depositType,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.depositType = $event))
                  }, {
                    label: _withCtx(() => [
                      _hoisted_16
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createVNode(_component_BalBtn, {
                    color: _ctx.requiresApproval ? 'primary' : 'gradient',
                    disabled: !_ctx.isDepositInputValid,
                    onClick: _withModifiers(_ctx.deposit, ["prevent"])
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.requiresApproval ? _ctx.$t('approve') : _ctx.$t('stakeTokens')), 1)
                    ]),
                    _: 1
                  }, 8, ["color", "disabled", "onClick"])
                ], 64))
              : _createCommentVNode("", true),
            (_ctx.activeTab === 'unlock')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  (_ctx.halter)
                    ? (_openBlock(), _createBlock(_component_TokenInput, {
                        key: 0,
                        amount: _ctx.amountToUnlock,
                        "onUpdate:amount": _cache[5] || (_cache[5] = ($event: any) => (_ctx.amountToUnlock = $event)),
                        isValid: _ctx.isUnlockInputValid,
                        "onUpdate:isValid": _cache[6] || (_cache[6] = ($event: any) => (_ctx.isUnlockInputValid = $event)),
                        customBalance: _ctx.formatBn(_ctx.locked),
                        address: _ctx.halter.address,
                        weight: 0,
                        name: _ctx.halter.address,
                        fixedToken: "",
                        hideInCurrency: ""
                      }, null, 8, ["amount", "isValid", "customBalance", "address", "name"]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_BalBtn, {
                    color: "gradient",
                    disabled: !_ctx.isUnlockInputValid,
                    onClick: _withModifiers(_ctx.unlock, ["prevent"])
                  }, {
                    default: _withCtx(() => [
                      _hoisted_17
                    ]),
                    _: 1
                  }, 8, ["disabled", "onClick"])
                ], 64))
              : _createCommentVNode("", true),
            (_ctx.activeTab === 'withdraw')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  _createVNode(_component_BalRadio, {
                    name: "depositType",
                    value: "unlocked",
                    modelValue: _ctx.depositType,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.depositType = $event))
                  }, {
                    label: _withCtx(() => [
                      _hoisted_18
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createVNode(_component_BalRadio, {
                    name: "depositType",
                    value: "locked",
                    modelValue: _ctx.depositType,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.depositType = $event))
                  }, {
                    label: _withCtx(() => [
                      _createElementVNode("div", _hoisted_19, " Withdraw your unlocked tokens (" + _toDisplayString(_ctx.formatBn(_ctx.unlocked)) + " HALT) ", 1)
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  (_ctx.depositType === 'unlocked')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (_ctx.halter)
                          ? (_openBlock(), _createBlock(_component_TokenInput, {
                              key: 0,
                              amount: _ctx.amountToWithdraw,
                              "onUpdate:amount": _cache[9] || (_cache[9] = ($event: any) => (_ctx.amountToWithdraw = $event)),
                              isValid: _ctx.isWithdrawInputValid,
                              "onUpdate:isValid": _cache[10] || (_cache[10] = ($event: any) => (_ctx.isWithdrawInputValid = $event)),
                              customBalance: _ctx.formatBn(_ctx.availableForDepositType),
                              address: _ctx.halter.address,
                              weight: 0,
                              name: _ctx.halter.address,
                              fixedToken: "",
                              hideInCurrency: ""
                            }, null, 8, ["amount", "isValid", "customBalance", "address", "name"]))
                          : _createCommentVNode("", true)
                      ], 64))
                    : _createCommentVNode("", true),
                  _createVNode(_component_BalBtn, {
                    color: "gradient",
                    disabled: 
                _ctx.depositType === 'unlocked'
                  ? !_ctx.isWithdrawInputValid
                  : _ctx.unlocked.isZero()
              ,
                    onClick: _withModifiers(_ctx.withdraw, ["prevent"])
                  }, {
                    default: _withCtx(() => [
                      _hoisted_20
                    ]),
                    _: 1
                  }, 8, ["disabled", "onClick"])
                ], 64))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      })
    ]),
    _hoisted_21,
    _createVNode(_component_BalCard, null, {
      default: _withCtx(() => [
        _createVNode(_component_BalTable, {
          columns: _ctx.unlockingColumns,
          data: _ctx.normalizedPurgatory
        }, null, 8, ["columns", "data"])
      ]),
      _: 1
    })
  ]))
}